module.exports = __webpack_public_path__ + "static/img/thumb-certified-forest-lands.ae12770.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumb-certified-forest-lands.png
// module id = 85
// module chunks = 0